import { Link } from '@mui/material';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { CrudFilters, useGo, useMany } from '@refinedev/core';
import { DeleteButton, List, useDataGrid } from '@refinedev/mui';

import { MODULE_CONTENT_MAP } from '@attackiq/constants';

import { Module, ModuleContent } from '../../types';

const ModuleContentList = () => {
  const { dataGridProps, search } = useDataGrid<ModuleContent>({
    onSearch: search => {
      const filters: CrudFilters = [];

      filters.push({
        field: 'search',
        value: search,
        operator: 'eq'
      });

      return filters;
    },

    filters: {
      initial: [
        {
          field: 'search',
          value: '',
          operator: 'eq'
        }
      ]
    }
  });
  const modulesIds = dataGridProps.rows.map((item: ModuleContent) => item.module_id);
  const {
    result: modulesData,
    query: { isLoading: isLoadingModules }
  } = useMany<Module>({
    resource: 'modules',
    ids: [...new Set(modulesIds)],
    queryOptions: {
      enabled: modulesIds.length > 0
    }
  });
  const go = useGo();

  const columns: GridColDef<ModuleContent>[] = [
    {
      field: 'content_type',
      headerName: 'Model',
      renderCell: params => MODULE_CONTENT_MAP[params.row.content_type_model],
      flex: 1
    },
    {
      field: 'content_object__name',
      headerName: 'Name',
      renderCell: params => params.row.content_object?.name || params.row.content_object?.template_name,
      sortable: false,
      flex: 2
    },
    {
      field: 'content_object__description',
      headerName: 'Description',
      renderCell: params => params.row.content_object?.description || params.row.content_object?.template_description,
      sortable: false,
      flex: 2
    },
    {
      field: 'module__display_name',
      headerName: 'Module',
      renderCell: ({ row }) => {
        if (isLoadingModules) return 'Loading...';

        const module = modulesData?.data.find(item => item.id === row.module_id);

        const handleClick = () => {
          go({
            to: {
              resource: 'modules',
              action: 'show',
              id: row.module_id
            }
          });
        };

        return (
          <Link sx={{ cursor: 'pointer' }} onClick={handleClick}>
            {module?.display_name}
          </Link>
        );
      },
      flex: 1
    },
    {
      field: 'actions',
      headerName: 'Actions',
      renderCell: ({ row }) => {
        const name = row.content_object?.name || row.content_object?.template_name;
        return (
          <DeleteButton
            recordItemId={row.id}
            hideText
            confirmTitle={'Do you want to delete Module Content for "' + name + '" ?'}
          />
        );
      },
      sortable: false,
      maxWidth: 100
    }
  ];

  return (
    <List canCreate>
      <DataGridPro
        {...dataGridProps}
        filterModel={undefined}
        columns={columns}
        showToolbar
        pagination
        onFilterModelChange={({ quickFilterValues }) => {
          search(quickFilterValues?.join(' ') || '');
        }}
      />
    </List>
  );
};

export default ModuleContentList;
